import Collection from './collection.js';
import LeaveType from 'newModels/leave-type.js';
import Employee from 'newModels/employee.js';
import axios from 'axios';

export default class LeaveTypes extends Collection {
    url() {
        if (this.company) {
            return (
                `/LeaveTypes/getForCompany/${this.company.get('objectId')}`
            );
        }
        return '/LeaveTypes';
    }

    initialize(models, {company = null} = {}) {
        super.initialize(...arguments);
        this.model = LeaveType;
        this.company = company;
        this.pagination = false;
        if (!this.options.sortKey) {
            this.options.sortKey = 'createdAt';
        }
        if (!this.options.sortOrder) {
            this.options.sortOrder = 'descending';
        }
        return this;
    }

    comparator(a, b) {
        if (a.get('annual')) {
            return -1;
        }

        if (b.get('annual')) {
            return 1;
        }

        if (!a.get('paid')) {
            return 1;
        }

        if (!a.get('companyId')) {
            return -1;
        }

        if (!a.get('optional')) {
            return -1;
        }

        return (a.get('name') > b.get('name')) ? 1 : -1;
    }

    getActiveTypes() {
        return new LeaveTypes(this.filter(model => {
            return !model.get('hiddenAt');
        }), {company: this.company});
    }

    fetch() {
        // TODO support filters in getForCompany
        if (this.company) {
            return super.fetch();
        }

        return super.fetch(...arguments);
    }

    // The reason sync is overriden is so that we can transparently use
    // fetch() to get the leave types for a given company. Dunno if it's the
    // right call tho.
    sync(method, collection, options) {
        if (!this.company || method !== 'read') {
            return super.sync(...arguments);
        }

        options.url = this.finalUrl();
        options.headers = {'Authorization': app.user.getAccessToken().id};
        return super.sync(method, collection, options);
    }

    fetchBalances(employee, date = new Date()) {
        return (
            (typeof employee === 'string') ?
                new Employee({objectId: employee}).fetch() :
                Promise.resolve(employee)
        ).then(
            employee => this.fetchBalancesMap(employee, date)
        ).then(data => {
            try {
                console.log(
                    'Annual leave values - current entitled: ' + data.entitledNoCf['8A3RuXfS5w'] +
                    ' taken: ' + data.taken['8A3RuXfS5w'] +
                    ' cf: ' + (data.entitled['8A3RuXfS5w'] - data.entitledNoCf['8A3RuXfS5w']) +
                    ' balance: ' + (data.entitled['8A3RuXfS5w'] - data.taken['8A3RuXfS5w'])
                );
            } catch (e) {
                // ignore
            }

            Object.keys(data.taken).forEach(id => {
                const model = this.get(id);
                if (model) {
                    model.setTaken(data.taken[id]);
                }
            });

            Object.keys(data.defaultEntitled).forEach(id => {
                const model = this.get(id);
                if (model) {
                    model.setDefaultEntitled(data.defaultEntitled[id]);
                }
            });

            Object.keys(data.entitled).forEach(id => {
                const model = this.get(id);
                if (model) {
                    model.setEntitled(data.entitled[id]);
                }
            });

            Object.keys(data.cf || {}).forEach(id => {
                const model = this.get(id);
                if (model) {
                    model.setCarriedFoward(data.cf[id]);
                }
            });

            return this;
        }).catch(err => {
            throw err;
        });
    }

    fetchBalancesMap(employee, date = new Date(), isEndAtDate = false) {
        //we want the url without any company prefixes
        const url = new LeaveTypes(null, {}).finalUrl();

        return axios.get(
            `${url}/fetchBalances/${employee.get('objectId')}`,
            {
                params: {
                    typeIds: this.map(model => model.get('objectId')),
                    date: date,
                    isEndAtDate
                },
                headers: {'Authorization': app.user.getAccessToken().id}
            }
        ).then(r => r.data.result)
        .catch(err => {
            throw err.response.data.error;
        });
    }

    static fetchCarryForwardDays(employee) {
        const url = new LeaveTypes(null, {}).finalUrl();
        return axios.get(
            `${url}/fetchCarryForwardDays/${employee.get('objectId')}`,
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(r => r.data.result)
        .catch(err => {
            throw err.response.data.error;
        });
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/leave-types.js